import React, { useEffect } from 'react';
import classNames from 'classnames';
import { flowRight } from 'lodash';
import { TPAComponentsProvider } from '@wix/wix-ui-tpa/TPAComponentsConfig';
import App from '../../../common/components/app';
import PermissionsProvider from '../../../common/components/permissions-provider';
import PopoverRoot from '../../../common/components/popovers/popover-root';
import ResponsiveListener from '../../../common/components/responsive-listener/responsive-listener';
import { connect } from '../../../common/components/runtime-context';
import { withReduxStore } from '../../../common/components/runtime-context/with-redux-store';
import { getIsCreatedWithResponsiveEditor } from '../../../common/selectors/app-settings-selectors';
import {
  isEditor,
  getIsMobile,
  getIsRTL,
  isSeo as getIsSeo,
  getIsRendered,
} from '../../../common/store/basic-params/basic-params-selectors';
import MessageRoot from '../messages/message-root';
import ModalRoot from '../modals/modal-root';
import MyPosts from '../my-posts';
import MyPostsFrame from '../my-posts-frame';
import styles from './app-root.scss';

const MyPostsPage = () => (
  <MyPostsFrame>
    <MyPosts />
  </MyPostsFrame>
);

type Props = ReturnType<typeof mapRuntimeToProps>;

const AppRoot: React.FC<Props> = ({
  isEditor,
  createdWithResponsiveEditor,
  isMobile,
  isRtl,
  isSeo,
  isRendered,
}) => {
  useEffect(() => {
    if (isEditor && createdWithResponsiveEditor) {
      document.body.style.height = 'auto';
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isRendered) {
    return null;
  }

  return (
    <ResponsiveListener
      dataHook="my-posts-page-root"
      className={classNames(styles.baseStyles, styles.root)}
    >
      <PermissionsProvider>
        <TPAComponentsProvider value={{ mobile: isMobile, rtl: isRtl, seo: isSeo }}>
          <App
            main={<MyPostsPage />}
            modalRoot={<ModalRoot />}
            messageRoot={<MessageRoot />}
            popoverRoot={<PopoverRoot />}
          />
        </TPAComponentsProvider>
      </PermissionsProvider>
    </ResponsiveListener>
  );
};

import { type AppState } from '../../../common/types';

const mapRuntimeToProps = (state: AppState) => ({
  isEditor: isEditor(state),
  isMobile: getIsMobile(state),
  isRtl: getIsRTL(state),
  isSeo: getIsSeo(state),
  createdWithResponsiveEditor: getIsCreatedWithResponsiveEditor(state),
  isRendered: getIsRendered(state),
});

export default flowRight(withReduxStore, connect(mapRuntimeToProps))(AppRoot);
